import uFuzzy from "@leeoniya/ufuzzy";

const searchRanker = new uFuzzy({
  intraMode: 1,
  intraIns: 1,
  intraSub: 1,
  intraTrn: 1,
  intraDel: 1,
  sort: ({ idx, chars, terms, interLft2, interLft1, start, intraIns, interIns, cases }) =>
    idx
      .map((_, i) => i)
      .sort(
        (ia, ib) =>
          chars[ib] - chars[ia] ||
          intraIns[ia] - intraIns[ib] ||
          terms[ib] + interLft2[ib] + 0.5 * interLft1[ib] - (terms[ia] + interLft2[ia] + 0.5 * interLft1[ia]) ||
          interIns[ia] - interIns[ib] ||
          start[ia] - start[ib] ||
          cases[ib] - cases[ia] ||
          idx[ia] - idx[ib],
      ),
});

const rankBySearch = (items, search, toHaystack) => {
  const needle = uFuzzy.latinize(search.trim());
  if (!needle) return items;
  const haystack = uFuzzy.latinize(items.map(toHaystack));
  const [idxs, info, order] = searchRanker.search(haystack, needle, 5, Infinity);
  if (!idxs) return items;
  if (!order) return idxs.map((i) => items[i]);
  return order.map((i) => items[info.idx[i]]);
};

export { rankBySearch };
